import { useEffect } from "react";
import { Box, Typography, MenuItem, Menu, IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import UploadIcon from "@mui/icons-material/Upload";
import LogoutIcon from "@mui/icons-material/Logout";
import { Dispatch, RootState } from "../store/store";
import { useDispatch, useSelector } from "react-redux";
import Imagen from "../assets/index";
import { useWidth } from "shared/hooks/HookDetailedConsultation/useWidth";
import styles from "./styles/Navbar.module.scss";
import { useNavigateToCustom } from "shared/hooks/useNavigateToCustom";
import { ButtonNotifications } from "./notifications/ButtonNotifications";
import { ModalNotifications } from "./notifications/ModalNotifications";
import { BreadcrumbsCustom } from "./breadcrumbs/Breadcrumbs.component";
import { breadcrumbNameElectronicDocumentsMap } from "shared/constants/breadcrumbNameMap.enum";
import { BagageUser } from "./sidebar/BagageUser";
import { ModalSignatureUpload } from "./sidebar/ModalSignatureUpload";
import { useInfoUser } from "shared/hooks/useInfoUser";
import { useCheckRoleAccess } from "shared/hooks/useCheckRoleAccess";
import { useAuth } from "shared/auth";
import "./styles/_menuUser.scss";

export const Navbar = () => {
  const dispatch = useDispatch<Dispatch>();

  const { width } = useWidth();
  const { notifications, menuDrawer, userMenu } = useSelector(
    (state: RootState) => state,
  );
  const { anchorOrigin } = notifications;
  const { anchorOrigin: userMenuAnchor } = userMenu;
  const openUserMenu = Boolean(userMenuAnchor);

  const handleUserMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    dispatch.userMenu.setAnchorOrigin(event.currentTarget);
  };

  const handleUserMenuClose = () => {
    dispatch.userMenu.setAnchorOrigin(null);
  };

  const handleOpenSignatureModal = () => {
    dispatch.userMenu.setShowSignatureModal(true);
    handleUserMenuClose();
  };

  const { navigateHome, navigateToInvoices } = useNavigateToCustom();
  const { user } = useInfoUser();
  const { checkRoles } = useCheckRoleAccess();
  const { authService } = useAuth();

  const handleLogout = () => {
    authService.logout();
    handleUserMenuClose();
  };

  const handleClickTopSearch = () => {
    dispatch.electronicDocuments.cleanState();
    navigateToInvoices();
  };

  useEffect(() => {
    dispatch.notifications.getNotificationsAsync({
      page: 1,
      status: "N",
      initialLoad: true,
    });
  }, [dispatch.notifications]);

  useEffect(() => {
    if (width < 900 && anchorOrigin) {
      dispatch.notifications.addStatemodal(null);
    }
  }, [width, anchorOrigin, dispatch.notifications]);

  return (
    <>
      {width > 900 ? (
        <Box className={styles.containerTopBar} data-testid="content_box">
          <Box className={styles.contentLogo} data-testid="logo-trazabilidad">
            {/* <img src={Imagen.logoTrazabilidad} alt='Trazabilidad' onClick={ navigateHome } data-testid='icon_trazabilidad'/> */}
            <img
              src={Imagen.logoGobernacion2024}
              alt="Logo Gobernación"
              onClick={navigateHome}
              data-testid="icon_gobernacion"
            />
          </Box>
          <Box className={styles.topBar}>
            <section className={styles.content1}>
              <div className={styles.content2}>
                <BreadcrumbsCustom
                  breadcrumbNameMap={breadcrumbNameElectronicDocumentsMap}
                  data-testid="breadcrumbs"
                />
              </div>

              <Box gap={3} className={styles.contentIcons}>
                <Box
                  className={styles.itemSearch}
                  onClick={handleClickTopSearch}
                  data-testid="navigateInvoices"
                >
                  <SearchIcon />
                  <span>Buscar</span>
                </Box>
                <ButtonNotifications />
                <Box
                  className={styles.userInfoNavbar}
                  onClick={handleUserMenuClick}
                  data-testid="user-info-navbar"
                >
                  <BagageUser user={user} data-testid="bagage-user" />
                  <Box className={styles.contentInfo}>
                    {user &&
                      (() => {
                        const parts = user.split(" ");
                        const lastTwo = parts.slice(-2).join(" ");
                        const first = parts.slice(0, -2).join(" ");
                        return (
                          <>
                            <Typography
                              data-testid="info-user"
                              className={styles.infoUser}
                            >
                              {first || lastTwo}
                            </Typography>
                            <Typography className={styles.infoUserLastName}>
                              {lastTwo}
                            </Typography>
                          </>
                        );
                      })()}
                  </Box>
                </Box>
              </Box>
            </section>
          </Box>
        </Box>
      ) : (
        <Box
          className={styles.containerTopBarMobile}
          data-testid="content_box_movil"
        >
          <Box className={styles.contentMobile}>
            <IconButton
              aria-label="btn_toogle_menu"
              size="large"
              edge="start"
              color="success"
              sx={{ mr: 2 }}
              onClick={dispatch.menuDrawer.toogleMenu}
              data-testid="menu-mobile"
            >
              <MenuIcon />
            </IconButton>
            <Box
              className={styles.logoTrazabilidad}
              onClick={navigateHome}
              data-testid="icon_gobernacion_movil"
            >
              <img src={Imagen.logoGobernacionAntioquia} alt="trazabilidad" />
            </Box>
            {!menuDrawer.open && (
              <Box
                className={styles.itemSearchMobile}
                onClick={navigateToInvoices}
                data-testid="navigate_invoices_movil"
              >
                <SearchIcon />
              </Box>
            )}
          </Box>
        </Box>
      )}
      {anchorOrigin && <ModalNotifications />}
      {userMenu.showSignatureModal && <ModalSignatureUpload />}
      <Menu
        anchorEl={userMenuAnchor}
        id="user-menu"
        open={openUserMenu}
        onClose={handleUserMenuClose}
        className="menuUser"
        PaperProps={{
          elevation: 0,
        }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        disableAutoFocusItem={true}
        disableEnforceFocus={true}
        data-testid="user-menu"
      >
        <Box className="bodyContainer">
          {checkRoles(["TFE.Auditor"]) && (
            <MenuItem
              onClick={handleOpenSignatureModal}
              className="menuItem"
              data-testid="menu-item-signature"
            >
              <UploadIcon className="menuIcon" />
              <Typography className="menuText">
                Cargar imagen firma digital
              </Typography>
            </MenuItem>
          )}
          <MenuItem
            onClick={handleLogout}
            className="menuItem"
            data-testid="menu-item-logout"
          >
            <LogoutIcon className="menuIcon" />
            <Typography className="menuText">Cerrar sesión</Typography>
          </MenuItem>
        </Box>
      </Menu>
    </>
  );
};
